import { GridColDef } from "@mui/x-data-grid";

/**
 * Column definitions for the roles data grid
 * 
 * Defines the structure and properties of columns displayed in the roles list:
 * - Role name
 *
 * Each column is configured with:
 * - Field identifier matching data properties
 * - Localized header name
 * - Flex sizing for responsive layout
 *
 * @type {GridColDef[]} Array of column definition objects for MUI X Data Grid
 */
export const columns: GridColDef[] = [
  {
    field: "name",
    headerName: "Name",
    flex: 1,
  },
];
